var _defs, _g;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgPlayCircle(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 80 80",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    focusable: "false",
    width: "1em",
    height: "1em"
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    d: "M30.45152 57a1.47624 1.47624 0 01-.72576-.19427c-.44939-.26044-.7261-.74188-.72576-1.26276V24.45972c-.00033-.52088.27637-1.00232.72576-1.26276a1.41786 1.41786 0 011.44185 0l27.0951 15.54163c.4553.25597.73729.73892.73729 1.26275 0 .52384-.28198 1.0068-.7373 1.26276L31.1676 56.80573A1.43767 1.43767 0 0130.45153 57z",
    id: "play-circle_svg__a"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("circle", {
    fill: "#FDB717",
    cx: 40,
    cy: 40,
    r: 40
  }), /*#__PURE__*/React.createElement("use", {
    fill: "#000",
    fillRule: "nonzero",
    xlinkHref: "#play-circle_svg__a"
  }))));
}

export default __webpack_public_path__ + "ondemand/static/8b50f6e88/icons/play-circle.svg";
export { SvgPlayCircle as ReactComponent };